<template>
  <div id="offers_by_currency_pair" class="report_card" v-bind:class="$mq">
  <b>Offers By Currency Pair</b>

  <!-- XXX: very ugly but chart is getting cut off otherwise ! -->
  <div v-if="have_data" style="height: 300; width: 125%; transform: translate(50, 0)">
  <apexchart type=pie
             v-bind:options="chart_options"
             v-bind:series="top_offers_by_currency_pair"
             v-bind:height="($mq == 'sm' || $mq == 'md') ? 150 : 300" />
  </div>

  <b-list-group id="offers_by_currency_pair_list" v-if="$mq != 'sm'">
    <b-list-group-item v-for="cp in currency_pairs"
                       v-bind:key="cp"
                       class="col-6 currency_pair_offers"
                v-bind:class="$mq">
      <b>{{cp}}</b>: {{data[cp] | round | delim}}
    </b-list-group-item>
  </b-list-group>
  </div>
</template>

<script>
export default {
  name: 'OffersByCurrencyPair',

  computed : {
    data : function(){
      return this.$store.state.report.data["offers_by_currency_pair"]; 
    },

    have_data : function(){
      return !!this.data;
    },

    currency_pairs : function(){
      if(!this.have_data) return;

      return Object.keys(this.data).sort(function(c1, c2){
                      return parseInt(this.data[c2]) -
                             parseInt(this.data[c1])
                    }.bind(this));
    },

    top_currency_pairs : function(){
      if(!this.have_data) return;

      return this.currency_pairs.slice(0, 5)
    },

    top_offers_by_currency_pair : function(){
      if(!this.have_data) return;

      return this.top_currency_pairs.map(function(c){
        return parseInt(this.data[c])
      }.bind(this));
    },

    chart_options : function(){
      if(!this.have_data) return;

      return {labels : this.top_currency_pairs,
              legend : {offsetX : 75}};
    }
  }
}
</script>

<style scoped>
#offers_by_currency_pair{
  padding: 25px;
}

#offers_by_currency_pair.sm{
  padding: 5px;
}

#offers_by_currency_pair_list{
  flex-direction: row;
  flex-wrap: wrap;
}

.currency_pair_offers{
  border-left: 1px solid blue;
  margin-bottom: 2px;
}

.currency_pair_offers.sm{
  padding: 3px;
}
</style>
